<template>
  <b-row>
    <b-col cols="12" class="w-full p-2 bg-white rounded-xl shadow-md">
      <!--      <b-card>-->
      <!--        <b-card-code>-->
      <b-card-title>Upcoming Appointment</b-card-title>

      <div
        v-if="data.length > 0"
        ref="scrollContainer"
        class="log-scrollable"
        @scroll="handleScroll"
      >
        <div
          v-for="(lead, index) in data"
          :key="index"
          class="alert alert-warning mx-1 mb-1 p-1 cursor-pointer"
          v-on:click="onShowPage(lead?.id)"
        >
          <b
            ><feather-icon icon="BriefcaseIcon" />
            <span class="text-black">{{ lead.title }}</span></b
          >
          <p class="mt-1">
            <feather-icon icon="ClockIcon" />
            {{ formatDate(lead.next_contact_date) }}
          </p>
        </div>
      </div>

      <div v-else class="text-center">
        <b>No Data Found</b>
      </div>
      <!--        </b-card-code>-->
      <!--      </b-card>-->
    </b-col>
  </b-row>
</template>

<script>
import { BCol, BRow, BCard, BCardTitle } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import BCardCode from "@core/components/b-card-code";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";

export default {
  name: "LeadUpcomingAppointment",
  components: {
    BCardActions,
    AppTimelineItem,
    BCardCode,
    BCardTitle,
    BRow,
    BCol,
    BCard,
  },
  props: {
    viewAs: {
      type: String,
      default: "employee",
    },
    selectedUserId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      data: [],
      currentPage: 1,
      perPage: 5,
      lastPage: false,
      loading: false,
    };
  },
  mounted() {
    this.loadItems();
  },
  watch: {
    selectedUserId(newVal) {
      // 👈 watch for changes and reload
      this.currentPage = 1;
      this.data = [];
      this.lastPage = false;
      this.loadItems();
    },
  },
  methods: {
    onShowPage(id) {
      const routeData = this.$router.resolve({
        name: "admin-lead-details",
        params: { id },
      });
      window.open(routeData.href, "_blank");
    },
    formatDate(date) {
      return this.$moment(date).format("DD MMM YYYY, h:mm A");
    },
    handleScroll(event) {
      const scrollContainer = event.target;
      const bottomReached =
        scrollContainer.scrollTop + scrollContainer.clientHeight >=
        scrollContainer.scrollHeight - 10;

      if (bottomReached && !this.loading) {
        this.loadItems();
      }
    },
    async loadItems() {
      if (this.loading || this.lastPage) return;

      this.loading = true;
      try {
        const response = await this.$api.get(
          `api/leads/appointments/upcoming?view=${this.viewAs}`,
          {
            params: {
              page: this.currentPage,
              per_page: this.perPage,
              user_id: this.selectedUserId,
            },
          }
        );

        const { data, meta } = response.data;

        this.data.push(...data);
        this.currentPage++;

        if (this.currentPage > meta.last_page) {
          this.lastPage = true;
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error loading activity log",
            icon: "AlertCircleIcon",
            variant: "danger",
            text: error?.response?.data?.message ?? error.message,
          },
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
.log-scrollable {
  overflow-y: scroll;
}
</style>
